export class ListNode<T> {
  next: ListNode<T> | null

  data: T

  constructor(data: T) {
    this.data = data // 节点数据
    this.next = null // 指向下一个节点的指针
  }
}

export class LinkedList<T> {
  head: ListNode<T> | null

  constructor() {
    this.head = null // 链表的头节点
  }

  // 在链表末尾添加节点
  append(data: T) {
    const newNode = new ListNode(data)
    if (!this.head) {
      this.head = newNode
    }
    else {
      let current = this.head
      while (current.next) {
        current = current.next
      }
      current.next = newNode
    }
  }

  // 在链表头部添加节点
  prepend(data: T) {
    const newNode = new ListNode(data)
    newNode.next = this.head
    this.head = newNode
  }

  contains(data: T): boolean {
    let current = this.head
    while (current) {
      if (current.data === data) {
        return true
      }
      current = current.next
    }
    return false
  }

  // 删除指定数据的节点
  delete(data: T) {
    if (!this.head) {
      return
    }
    if (this.head.data === data) {
      this.head = this.head.next
      return
    }
    let current = this.head
    while (current.next) {
      if (current.next.data === data) {
        current.next = current.next.next
        return
      }
      current = current.next
    }
  }

  // 打印链表中的所有节点数据
  print() {
    let current = this.head
    while (current) {
      console.log(current.data)
      current = current.next
    }
  }
}
